// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dNOp","label":"styles_label__8Y4fT"};